import { FbBetModel } from './FbBetModel';
import { FbTipPrice } from './FbTipPrice';
import { FbTipsterInfo } from './FbTipsterInfo';
export class FbPersonalTips {
  public tipId: number;
  public tipsterInfo: FbTipsterInfo;
  public associateType: number;
  public note: string;
  public image: string;
  public fbBetList: Array<FbBetModel>;
  public fbTipPrice: FbTipPrice;
  public availableForPurchase: boolean;
  public packageId: number;
  public purchaseDate: string;
  public betAmount: number;
  public currentBetAmount: number;
  public dividend: number;
  public allowRefund: boolean;

  constructor(tipId: number, tipsterInfo: FbTipsterInfo, associateType: number, note: string, image: string,
      fbBetList: Array<FbBetModel>, fbTipPrice: FbTipPrice, availableForPurchase: boolean, packageId: number,
      purchaseDate: string, betAmount: number, currentBetAmount: number, dividend: number, allowRefund: boolean) {
    this.tipId = tipId;
    this.tipsterInfo = tipsterInfo;
    this.associateType = associateType;
    this.note = note;
    this.image = image;
    this.fbBetList = fbBetList;
    this.fbTipPrice = fbTipPrice;
    this.availableForPurchase = availableForPurchase;
    this.packageId = packageId;
    this.purchaseDate = purchaseDate;
    this.betAmount = betAmount;
    this.currentBetAmount = currentBetAmount;
    this.dividend = dividend;
    this.allowRefund = allowRefund;
  }
}



// WEBPACK FOOTER //
// ./src/model/FbPersonalTips.ts